import React from "react";
import { Check } from "lucide-react";
import LpCta from "./LpCta";
import { CREDENTIALS, DOCTOR } from "./lpData";

const LpAuthority = () => (
  <section className="section-pad bg-[#E6F8FF]" data-testid="lp-authority">
    <div className="aevos-container grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-5 order-2 lg:order-1">
        <img
          src="/assets/dr-guilherme.jpg"
          alt="Dr. Guilherme Affonso de jaleco na clínica AEVOS"
          className="w-full h-auto max-h-[560px] object-cover object-top border border-[#E0E0E0]"
          data-testid="lp-authority-photo"
          draggable={false}
        />
      </div>

      <div className="lg:col-span-7 order-1 lg:order-2">
        <h2 className="font-display font-bold text-3xl md:text-5xl leading-[1.08]">{DOCTOR.name}</h2>
        <p className="mt-5 text-[#333333] text-base md:text-lg leading-relaxed">
          Médico especialista em Medicina Preventiva e Social, com residência pelo Hospital
          Sírio-Libanês e atuação em emagrecimento e saúde metabólica.
        </p>
        <p className="mt-4 text-[#333333] text-base leading-relaxed">
          À frente da AEVOS, em Mogi das Cruzes, integra avaliação clínica, composição corporal e
          hábitos de vida para construir um cuidado individualizado, acompanhado e ajustado ao longo
          do tempo.
        </p>

        <ul className="mt-8 space-y-3" data-testid="lp-credentials">
          {CREDENTIALS.map((c) => (
            <li key={c} className="flex items-start gap-3 text-[#333333] text-sm md:text-base">
              <Check size={18} className="text-[#00C4FF] mt-0.5 flex-shrink-0" />
              {c}
            </li>
          ))}
        </ul>
        <p className="mt-5 text-xs tracking-[0.14em] uppercase text-black font-semibold">{DOCTOR.crm}</p>

        <blockquote className="mt-8 border-l-2 border-[#00C4FF] pl-5 text-black font-display font-medium text-base md:text-lg">
          Escutar sua história, investigar suas dificuldades e explicar as possibilidades de cuidado
          fazem parte de cada decisão.
        </blockquote>

        <div className="mt-10">
          <LpCta location="authority">Agendar consulta com o Dr. Guilherme</LpCta>
        </div>
      </div>
    </div>
  </section>
);

export default LpAuthority;
